<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="systemDictionaryVo.pkid > 0 ? '编辑' : '新建'"
        class="systemDictionaryEdit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="systemDictionaryVo"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col>
            <el-form-item label="字典名称" prop="dictionaryName">
              <el-input v-model="systemDictionaryVo.dictionaryName" placeholder="请输入字典名称"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="字典编码" prop="dictionaryNo">
              <el-input v-model="systemDictionaryVo.dictionaryNo" placeholder="请输入字典编码"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        submitLoading: false,
        contentLoading: false,
        dialogVisible: false,
        systemDictionaryVo: {
          dictionaryNo: "",
          dictionaryName: "",
          pkid: 0,
        },
        ruleValidate: {
          dictionaryName: {
            required: true,
            message: "请输入字典名称",
            trigger: "blur",
          },
          dictionaryNo: {
            required: true,
            message: "请输入字典编码",
            trigger: "blur",
          },
        },
      };
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.systemDictionaryVo = Object.assign(this.systemDictionaryVo,row);
        }
      },

      // 新建
      addDictionary() {
        this.submitLoading = true;
        this.$http
          .post("basic", "dictionaries", this.systemDictionaryVo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("添加成功");
              this.dialogVisible = false;
            }
            this.submitLoading = false;
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },

      // 编辑
      editDictionary() {
        this.submitLoading = true;
        this.$http
          .put("basic", "dictionaries", this.systemDictionaryVo)
          .then((resp) => {
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("编辑成功");
              this.dialogVisible = false;
            }
            this.submitLoading = false;
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },

      // 提交
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.systemDictionaryVo.pkid) {
              this.addDictionary();
            } else {
              this.editDictionary();
            }
          }
        });
      },
    },
  };
</script>
